/**
 * Created by Artagan on 11.11.16.
 */
require('../components/jquery.scrollTo');

import Video from '../components/video';
import ScrollTo from '../components/scrollTo';
import Overlay from '../components/overlay';
(function () {
    $(".arguments-increase").each(function() {
        let step = $(this).data("counter-step");
        let to = $(this).data("counter");
        let decimal = $(this).data("counter-decimal");

        $(this).countTo({
            to: to,
            decimals: decimal,
            refreshInterval: 1,
            speed: 300
        });
    });

    //FAQ scrolovani
    $('#faq').on('shown.bs.collapse', function (event) {
        ScrollTo.positionOf($(event.target).parent());
    });

    $('.faq-item').on('show.bs.collapse', function () {
        $(this).addClass("opened");
    }).on('hide.bs.collapse', function () {
        $(this).removeClass("opened");
    });

    $('[play-video]').on('click', function(val) {
        var dataUrl = $('.hk-video').data('youtube-video');
        Video.play_video(dataUrl);
        ScrollTo.positionOf(0);
    });


    // open conditions popup
    Overlay.init();
    $('.conditions').on('click', (event) => {
        Overlay.show_overlay();
    event.preventDefault();
});

    $('#lander-electricity-price-comparison, #lander-complexity-index').each(function() {
        $('#video-modal-trigger').on('click', function() {
            Video.play_video('jny5WY8qwMw');
            ScrollTo.positionOf(0);
        });

        if($('#faq').length) {
            setTimeout(function() {
                let $faq = $('#faq');
                if (!$faq.isOnScreen()) {
                    $faq.collapse('hide');
                }
            }, 5000);
        }
    });


})();



// WEBPACK FOOTER //
// ./app/Resources/assets/js/scripts/homepage.js